module.exports = __webpack_public_path__ + "static/home_sp-aae97309b33d066a3def46fb1bde64a2.jpeg";